import type { ShopMetadataRouter } from "replo-publisher/src/trpc/routers/shopMetadata";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: shopMetadataRouter,
  client: shopMetadataClient,
  utils: shopMetadataUtils,
  options: shopMetadataOptions,
} = createTrpcRouterConfig<ShopMetadataRouter>({
  path: "shopMetadata",
  queryClient: getNamespacedQueryClient("shopMetadata"),
});

export {
  shopMetadataClient,
  shopMetadataRouter,
  shopMetadataUtils,
  shopMetadataOptions,
};
